module.exports = __webpack_public_path__ + "static/img/rizqia-ac-sertifikat-kompetensi.6a5198d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/certificate/rizqia-ac-sertifikat-kompetensi.jpg
// module id = yznd
// module chunks = 0